export const Footer = () => (
  <div class="footer">
    <p>QR Code Generator - Anartz Mugika Ledo - { new Date().getFullYear()}</p>
  </div>
);
